export enum SocialNetworkTypes {
    FACEBOOK = "Facebook",
    TWITTER = "Twitter",
    INSTAGRAM = "Instagram",
    MEWE = "MeWe"
}